import React from 'react'
import "./SubStyle.css"

const Acc_Payroll = () => {
  return (
    <section className="OurServices">
     <h1 className="OurServices-title">Payroll</h1>
      <p className="OurServices-pera">Take the stress out of managing employee wages, tax deductions, pensions, and compliance. Our payroll service ensures your staff are paid correctly and on schedule while keeping your business aligned with current regulations.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Acc_Payroll
